__turbopack_context__.v({
  "map": "ShopsMap-module-scss-module__DT40jG__map",
  "root": "ShopsMap-module-scss-module__DT40jG__root",
});
